import { render, staticRenderFns } from "./rewardRunForItEdit.vue?vue&type=template&id=0b7c6a68&scoped=true&"
import script from "./rewardRunForItEdit.vue?vue&type=script&lang=js&"
export * from "./rewardRunForItEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c6a68",
  null
  
)

export default component.exports